import React from "react";
import { Card, Select, Rate, Spin } from "antd";
import { useGetTopProductQuery } from "@/services/api/dashboard/dashboardApi";
import { formatCurrency } from "@/utils/helper";

const { Option } = Select;

const BestsellerProducts = () => {
  const {
    data: topProductsData,
    isLoading: topProductsLoading,
    isError: topProductsError,
  } = useGetTopProductQuery();

  const topProducts = topProductsData?.top_products || [];
  if (topProductsLoading) {
    return (
      <Card
        title="Top performing Orders by Categories"
        className="shadow-sm border border-gray-100"
      >
        <Spin size="large" />
      </Card>
    );
  }

  if (topProductsError) {
    return (
      <Card
        title="Top performing Orders by Categories"
        className="shadow-sm border border-gray-100"
      >
        <div className="h-64 flex items-center justify-center">
          <p className="text-red-500">Error loading data</p>
        </div>
      </Card>
    );
  }
  return (
    <Card
      title="Bestseller Product"
      className="shadow-sm border border-gray-100"
      extra={
        <Select defaultValue="all" size="small" className="w-20">
          <Option value="all">All</Option>
          <Option value="week">Week</Option>
          <Option value="month">Month</Option>
        </Select>
      }
      styles={{ body: { padding: "16px" } }}
    >
      <div className="space-y-4">
        {topProducts?.slice(0, 5).map((product, index) => (
          <div
            key={product.id}
            className="flex items-center justify-between  border-b border-gray-50 last:border-b-0"
          >
            <div className="flex items-center space-x-1 flex-1">
              {/* Rank Number */}
              <div className="flex-shrink-0 w-8">
                <span
                  className={`text-sm font-medium ${
                    index < 3 ? "text-gray-900" : "text-gray-500"
                  }`}
                >
                  #{index + 1}
                </span>
              </div>

              {/* Product Image */}
              <div className="flex-shrink-0">
                <img
                  src={product.product_url}
                  alt={product.product_name}
                  className="w-10 h-10 rounded-lg object-cover"
                />
              </div>

              {/* Product Details */}
              <div className="flex-1 min-w-0">
                <div
                  className="max-w-[100px] text-sm font-medium text-[#0A0A0A] truncate"
                  title={product.product_name}
                >
                  {product.product_name}
                </div>
                <div className="flex items-center mt-1">
                  <Rate
                    disabled
                    allowHalf
                    defaultValue={product.product_rating}
                    style={{ fontSize: "12px", color: "#FFA500" }}
                  />
                  {/* <span className="text-xs text-gray-500 ml-2">
                    ({product.reviewCount})
                  </span> */}
                </div>
              </div>
            </div>

            {/* Price */}
            <div className="flex-shrink-0 ml-4">
              <div
                className="text-sm font-semibold text-gray-900 truncate"
                title={formatCurrency(product.total_amount)}
              >
                {formatCurrency(product.total_amount)}
              </div>
            </div>
          </div>
        ))}

        {/* View More Button
        <div className="flex justify-center pt-4">
          <button className="bg-blue-500 text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 transition-colors">
            48 📊 48
          </button>
        </div> */}
      </div>
    </Card>
  );
};

export default BestsellerProducts;
